import React from 'react';
import { Link } from 'react-router-dom';

import '../css/Collaborative.css';

const Collaborative = () => {
    return (
        <div className="collaborative">
            <div className="collaborative-content">
                <div className="collaborative-title">
                    <div style={{ fontSize: '1.7rem', fontWeight: 'bold' }}>Business Partners</div>비즈니스 파트너사
                </div>

                <div className="collaborative-description">
                    <div className="collaborative-description-block">
                        <b style={{ fontSize: '1.5rem' }}>한국자산관리협회</b>
                        <br />
                        한국자산관리협회는 가계와 기업의 사회적·경제적 가치를 높이는 자산관리 전문기관입니다. <br />
                        세무·회계, 주식, 펀드, 은행, 보험, 정책자금, 기업 인증 등 각 분야의 전문가들이 고객의 자산을
                        철저히 분석하고, 체계적인 관리와 계획을 통해 안정적인 목표 달성을 지원합니다.
                    </div>
                    <div className="collaborative-description-block">
                        <img src={process.env.PUBLIC_URL + '/M4M-black.svg'} width="300px"></img>
                        M4Markets는 **세이셸 금융감독청(FSA)**의 규제를 받는 글로벌 브로커로, 투명하고 안정적인 금융
                        서비스를 제공합니다.
                        <br />
                        유럽(CySEC), 두바이(DFSA), 남아프리카(FSCA) 등 주요 금융 규제 기관의 승인을 받았으며, 2022년
                        한국 시장에 진출해 경쟁력 있는 수수료와 다양한 혜택을 제공합니다. 최고의 스프레드 브로커로
                        선정된 M4Markets는 신뢰할 수 있는 거래 환경을 제공합니다.
                    </div>
                    <div className="collaborative-description-block">
                        <img src={process.env.PUBLIC_URL + '/golden-nine.png'} width="300px"></img>
                        골든나인은 파나마에 위치한 증권사로, 조세피난처의 이점을 활용해 세금 절감 및 자산 보호 솔루션을
                        제공합니다.
                        <br />
                        또한, 금융 자문 서비스를 통해 고객의 투자 전략을 최적화하여 효율적인 자산 관리를 지원합니다.
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Collaborative;
